import { useState } from 'react'

import type { DashboardOverviewServices } from '../../api/overview/overviewTypes'
import { servicesFrame, servicesLeaders } from '../../data/bookingServices'
import { cn } from '../../utils/cn'
import { absoluteBox } from '../../utils/geometry'
import { ChartCanvas } from './ChartCanvas'
import { ServiceDonutChart, ServiceSliceLabels } from './ServiceDonutChart'

type BookingServicesCardProps = {
  bookingServices: DashboardOverviewServices
}

export const BookingServicesCard = ({ bookingServices }: BookingServicesCardProps) => {
  const [activeId, setActiveId] = useState<string | null>(null)
  const { slices, totalCount } = bookingServices

  return (
    <ChartCanvas frame={servicesFrame} className="bg-dash-violet">
      <h2 className="absolute left-[18px] top-[18px] whitespace-nowrap font-host text-[16px] font-medium leading-normal text-white">
        Booking Services
      </h2>

      {servicesLeaders.map((leader) => {
        const dimmed = activeId !== null && activeId !== leader.id

        return (
          <div
            key={leader.id}
            className={cn(
              'absolute transition-opacity duration-300 motion-reduce:transition-none',
              leader.mirrored && '-scale-x-100',
              dimmed ? 'opacity-30' : 'opacity-100',
            )}
            style={absoluteBox(leader)}
          >
            <span className="absolute block" style={{ inset: leader.bleed }}>
              <img alt="" aria-hidden className="block size-full max-w-none" src={leader.src} />
            </span>
          </div>
        )
      })}

      <ServiceDonutChart
        slices={slices}
        totalCount={totalCount}
        activeId={activeId}
        onActiveChange={setActiveId}
      />
      <ServiceSliceLabels
        slices={slices}
        activeId={activeId}
        onActiveChange={setActiveId}
      />
    </ChartCanvas>
  )
}
